import { startOfDay, endOfDay, isValid } from 'date-fns';

const assertValidDate = (date, fnName) => {
  if (!(date instanceof Date) || !isValid(date)) {
    throw new TypeError(`${fnName}: expected a valid Date`);
  }
};

export const toLocalDayStart = (date) => {
  if (date == null) return null;
  assertValidDate(date, 'toLocalDayStart');
  return startOfDay(date).toISOString();
};

export const toLocalDayEnd = (date) => {
  if (date == null) return null;
  assertValidDate(date, 'toLocalDayEnd');
  return endOfDay(date).toISOString();
};

export const toLocalDayRange = (start, end) => ({
  startISO: toLocalDayStart(start),
  endISO: toLocalDayEnd(end),
});
